module.exports = require("warning");


//////////////////
// WEBPACK FOOTER
// external "warning"
// module id = 15
// module chunks = 0